import { FEELING_ICONS } from '../../../../utils/feelingIcons';
import { ReviewOptionsField } from '../reviewOptionsField/reviewOptionsField';
import type {
  ReviewOption,
  ReviewOptionsFieldProps,
} from '../reviewOptionsField/reviewOptionsField';

export interface FeelingsFieldProps extends Pick<
  ReviewOptionsFieldProps,
  'onChange' | 'selectedIds'
> {
  options: Omit<ReviewOption, 'icon'>[];
}

/**
 * "How did this product make you feel?" section.
 * Options are `feeling` tags with icons from `FEELING_ICONS`.
 */
export function FeelingsField({ options, ...props }: FeelingsFieldProps) {
  const optionsWithIcons = options.map((option) => {
    const Icon = FEELING_ICONS[option.label];

    return { ...option, icon: Icon && <Icon color={null} size="md" /> };
  });

  return (
    <ReviewOptionsField
      {...props}
      isOptional
      legend="How did this product make you feel?"
      options={optionsWithIcons}
      testId="feelings-field"
    />
  );
}
